import { useState, useEffect } from 'react'
import StoneMap from './components/StoneMap'
import { fetchStonesForMap } from './utils/mapData'

export default function Map({ onBack }) {
  const [stones, setStones] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchStonesForMap().then(({ data, error }) => {
      if (error) setError('Could not load stones: ' + error.message)
      setStones(data)
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-gray-400">Loading map...</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="bg-gray-800 p-4 flex items-center justify-between">
        <h1 className="text-xl font-bold text-green-400">Granite Graph</h1>
        <button
          onClick={onBack}
          className="text-gray-400 text-sm hover:text-white"
        >
          Back
        </button>
      </div>

      <div className="p-4">
        <p className="text-green-400 font-bold mb-3">
          {stones.length} cataloged stone{stones.length !== 1 ? 's' : ''} with GPS
        </p>

        {error && (
          <div className="bg-red-900 text-red-200 p-3 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        {stones.length === 0 && !error && (
          <div className="bg-gray-800 rounded-lg p-4 mb-4">
            <p className="text-gray-400">No stones with GPS data yet.</p>
            <p className="text-gray-500 text-sm mt-1">Confirm matches in the field to add GPS locations.</p>
          </div>
        )}

        {stones.length > 0 && <StoneMap stones={stones} height="60vh" zoom={18} />}

        <div className="mt-4">
          <p className="text-gray-500 text-xs text-center">
            Tap a marker to see stone details
          </p>
        </div>
      </div>
    </div>
  )
}
